import React from "react";
import {
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import ArrowBack from "@material-ui/icons/ArrowBack";

const AppBarComponent = ({
  handleClose,
  handleSubmit,
  idName,
  disabled,
  title,
  resources,
  hasBackIcon,
  hasSaveButton = true,
  rightButtonResource,
}) => {
  return (
		<AppBar className="position-sticky">
			<Toolbar>
				<IconButton
					id={`close-new-${idName}`}
					edge="start"
					color="inherit"
					onClick={handleClose}
					aria-label={hasBackIcon ? "back" : "close"}
				>
					{hasBackIcon ? <ArrowBack /> : <Close />}
				</IconButton>
				<Typography variant="h6" style={{ flex: 1 }}>
					{title}
				</Typography>
				{hasSaveButton && (
					<Button
						id={`${idName}-save`}
						color="inherit"
						disabled={disabled}
						onClick={handleSubmit}
					>
						{rightButtonResource ?? resources["Save"]}
					</Button>
				)}
			</Toolbar>
		</AppBar>
	);
};

export default AppBarComponent;
